export default __webpack_public_path__ + "static/media/ESTRIMO.f0b29e92.png";